import React from 'react';
import { Euro } from '../Icons/CustomIcons';
import { IconHeader } from './Dialog';

const OPTIONS = [
  { value: 'free', label: 'Gratis' },
  { value: 'low', label: '0–10 CHF' },
  { value: 'medium', label: '10–30 CHF' },
  { value: 'high', label: '30+ CHF' },
];

/**
 * CostRange – Filtergruppe für Kosten.
 *
 * Props:
 *   value        – aktuell gewählter Wert ('free' | 'low' | 'medium' | 'high' | null)
 *   onChange(v)  – Callback mit neuem Wert; liefert null wenn „Alle" gewählt wird
 *   showAll      – zeigt den „Alle"-Button (Standard: false)
 *   fieldInfo    – optionaler Hilfetext für das FieldInfo-Icon
 *
 * Verwendung Filter:
 *   <CostRange
 *     value={filters.cost_range}
 *     onChange={(v) => updateFilter('cost_range', v)}
 *     showAll
 *   />
 *
 * Verwendung Formular:
 *   <CostRange
 *     value={formData.cost}
 *     onChange={(v) => setFormData(prev => ({ ...prev, cost: v }))}
 *     fieldInfo={info.cost}
 *   />
 */
export const CostRange = ({ value, onChange, showAll = false, fieldInfo = '' }) => {
  const displayValue = showAll ? (value ?? 'all') : value;

  const handleClick = (val) => {
    onChange(showAll && val === 'all' ? null : val);
  };

  return (
    <div className="filter">
      <IconHeader Icon={<Euro size={20} coinColor="var(--Colors-Accent-01, #1e3a5f)" textColor="#FFF" />} info={fieldInfo}>
        Kosten
      </IconHeader>
      <div className="filter__box">
        <div className="prop-btn-group">
          {showAll && (
            <button
              type="button"
              className={`prop-btn${displayValue === 'all' ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick('all')}
            >
              Alle
            </button>
          )}
          {OPTIONS.map(({ value: val, label }) => (
            <button
              key={val}
              type="button"
              className={`prop-btn${displayValue === val ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick(val)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
